export const allowedUsers: string[] = [
  'kelm@rackow-berlin.de',
  'eric.rockstaedt@schoolmaster.net',
  'tim.balzer@kbw-gruppe.de',
  'balzer@rackow-schulen.de',
  'mueller@rackow-schulen.de',
  'michel@rackow-berlin.de',
  'elwert@rackow-berlin.de',
  'klaus.vogt@kbw-gruppe.de'
];
